import { PudoTransactionTimerDropOffPendingWaitingDaysStackedBarChart } from '@frontend/chart/components';
import { FormattedMessage } from 'react-intl';

import { PudoTransactionTimerWaitingDaysStackedBarCard } from '../pudo-transaction-timer-waiting-days-stacked-bar-card.component';

export interface AwaitingDropOffProps {
    accountId: string;
    navigateUrl?: string;
}

export const AwaitingDropOff = ({ accountId, navigateUrl }: AwaitingDropOffProps) => (
    <PudoTransactionTimerWaitingDaysStackedBarCard
        accountId={accountId}
        navigateUrl={navigateUrl}
        title={
            <FormattedMessage
                id='pudo-dashboard.awaiting-drop-off'
                defaultMessage='Awaiting drop-off'
            />
        }
        Chart={PudoTransactionTimerDropOffPendingWaitingDaysStackedBarChart}
    />
);

export default AwaitingDropOff;
